var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          stripe: false,
          selection: _vm.hasBtn && _vm.selection,
          "right-toolbar-hide": "",
        },
        on: { handleSelectionChange: _vm.handleSelectionChange },
        scopedSlots: _vm._u(
          [
            {
              key: "baseForm",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessOrderAuditComSkuList.receivingStatus"
                            ),
                            prop: "receiveStatus",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "constant-key":
                                "ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST",
                            },
                            model: {
                              value: _vm.queryParams.receiveStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "receiveStatus", $$v)
                              },
                              expression: "queryParams.receiveStatus",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.businessType == _vm.ORDER_BUSINESS_TYPES.COMMON
                    ? [
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.deliveryStatus"
                                  ),
                                  prop: "deliveryStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.deliveryStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "deliveryStatus",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.deliveryStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.preemptionStatus"
                                  ),
                                  prop: "preemptionStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.preemptionStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "preemptionStatus",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.preemptionStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.sourceStatus"
                                  ),
                                  prop: "sourceStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.sourceStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "sourceStatus",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.sourceStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.suspendStatus"
                                  ),
                                  prop: "suspendStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.suspendStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "suspendStatus",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.suspendStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.syncPreempStatus"
                                  ),
                                  prop: "syncPreempStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.syncPreempStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "syncPreempStatus",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.syncPreempStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.syncDeliveryStatus"
                                  ),
                                  prop: "syncDeliveryStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.syncDeliveryStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "syncDeliveryStatus",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryParams.syncDeliveryStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.hasBtn
              ? {
                  key: "startBtnGroup",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onAction(
                                _vm.$t("BusinessOrderAuditComSkuList.receipt")
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessOrderAuditComSkuList.receipt")
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onAction(
                                _vm.$t("BusinessOrderAuditComSkuList.hangUp")
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessOrderAuditComSkuList.hangUp")
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onAction(
                                _vm.$t("BusinessOrderAuditComSkuList.hang")
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("BusinessOrderAuditComSkuList.hang"))
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuCode",
                      label: _vm.$t("goodsPage.skuCode"),
                      align: "center",
                      width: "114",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "giftFlag",
                      label: _vm.$t("BusinessOrderAuditComSkuList.giftFlag"),
                      align: "center",
                      width: "86",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: scope.row.giftFlag ? "success" : "info",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      _vm.STATUS_YES_NUM.bjGet(
                                        !!scope.row.giftFlag
                                      )
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "quantity",
                      label: _vm.$t("BusinessOrderAuditComSkuList.quantity"),
                      align: "center",
                      width: "81",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "thirdSaleAmount",
                      label: _vm.$t(
                        "BusinessOrderAuditComSkuList.thirdSaleAmount"
                      ),
                      align: "center",
                      width: "159",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$number2money(scope.row.thirdSaleAmount)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "outBalancePrice",
                      label: _vm.$t(
                        "BusinessOrderAuditComSkuList.outBalancePrice"
                      ),
                      align: "center",
                      width: "192",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$number2money(scope.row.outBalancePrice)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "innerSalePrice",
                      label: _vm.$t(
                        "BusinessOrderAuditComSkuList.innerSalePrice"
                      ),
                      align: "center",
                      width: "111",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$number2money(scope.row.innerSalePrice)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "innerBalancePrice",
                      label: _vm.$t(
                        "BusinessOrderAuditComSkuList.innerBalancePrice"
                      ),
                      align: "center",
                      width: "159",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$number2money(scope.row.innerBalancePrice)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "costAmount",
                      label: _vm.$t("BusinessOrderAuditComSkuList.costAmount"),
                      align: "center",
                      width: "81",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$number2money(scope.row.costAmount)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalCostAmount",
                      label: _vm.$t(
                        "BusinessOrderAuditComSkuList.totalCostAmount"
                      ),
                      align: "center",
                      width: "86",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$number2money(scope.row.totalCostAmount)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "transPrice",
                      label: _vm.$t("BusinessOrderAuditComSkuList.transPrice"),
                      align: "center",
                      width: "74",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$number2money(scope.row.transPrice)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.businessType == _vm.ORDER_BUSINESS_TYPES.COMMON
                    ? [
                        _c("el-table-column", {
                          attrs: {
                            prop: "deliveryStatus",
                            label: _vm.$t(
                              "BusinessOrderAuditComSkuList.deliveryStatus"
                            ),
                            align: "center",
                            width: "114",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST.bjGet(
                                              scope.row.deliveryStatus
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1410021758
                          ),
                        }),
                      ]
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      prop: "receivingStatus",
                      label: _vm.$t(
                        "BusinessOrderAuditComSkuList.receivingStatus"
                      ),
                      align: "center",
                      width: "109",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST.bjGet(
                                      scope.row.receivingStatus
                                    )
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.businessType == _vm.ORDER_BUSINESS_TYPES.COMMON
                    ? [
                        _c("el-table-column", {
                          attrs: {
                            prop: "preemptionStatus",
                            label: _vm.$t(
                              "BusinessOrderAuditComSkuList.preemptionStatus"
                            ),
                            align: "center",
                            width: "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST.bjGet(
                                              scope.row.preemptionStatus
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2148464719
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "sourceStatus",
                            label: _vm.$t(
                              "BusinessOrderAuditComSkuList.sourceStatus"
                            ),
                            align: "center",
                            width: "171",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(
                                              scope.row.sourceStatus
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3590935911
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "suspendStatus",
                            label: _vm.$t(
                              "BusinessOrderAuditComSkuList.hangUp"
                            ),
                            align: "center",
                            width: "142",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST.bjGet(
                                              scope.row.suspendStatus
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3069402996
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "syncPreempStatus",
                            label: _vm.$t(
                              "BusinessOrderAuditComSkuList.syncPreempStatus"
                            ),
                            align: "center",
                            width: "173",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST.bjGet(
                                              scope.row.syncPreempStatus
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2083652960
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "syncDeliveryStatus",
                            label: _vm.$t(
                              "BusinessOrderAuditComSkuList.syncDeliveryStatus"
                            ),
                            align: "center",
                            width: "181",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST.bjGet(
                                              scope.row.syncDeliveryStatus
                                            )
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1457208296
                          ),
                        }),
                      ]
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }